import React from 'react';
import { InputAdornment } from '@mui/material';

// Shared "$" prefix for the transfer dialog's money inputs. Live
// thousands-separator masking is now handled by `RhNumberField` (the fields
// using these props render through it): the displayed value carries commas
// while the value stored in the form stays a clean numeric string, so
// `yup.number()` still coerces it correctly.
export const CURRENCY_INPUT_PROPS = {
    startAdornment: <InputAdornment position="start">$</InputAdornment>,
};
